// import React, { useState, useEffect } from "react";
// import Modal from "react-bootstrap/Modal";
// import TableComponent from "../../Common/TableComponent/tableComponent";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEdit, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
// import { withTranslation } from "react-i18next";
// import { GetAllRoles, UpdatePassword } from "../../Apis/userCreationApi";
// import { CreateUsers } from "../../Apis/userCreationApi";
// import { UpdateUsers } from "../../Apis/userCreationApi";
// import { GetAllUsers } from "../../Apis/userCreationApi";
// import { GetCircleByMultipleZoneId } from "../../Apis/userCreationApi";
// import { GetWardByMultipleCircleId } from "../../Apis/userCreationApi";
// import { GetZone, GetCirclebyID } from "../../Apis/organizationApi";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { TableLoader } from "../../Common/ShimmerLoader";
// import "./userCreation.css";
// import Select from "react-select";
// import MUITable from "../../Common/MUITable";
// import isGHMC from "../../Common/helper/helpar";
// import { ExportUsersExcel } from "./exportUsers";

// const UserCreation = ({ t }) => {
//   const isProd = isGHMC();
//   const [lgShow, setLgShow] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [levels, setLevels] = useState([{ id: 1, value: "" }]);
//   const [role, setRole] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [options, setOptions] = useState([]);
//   const [isOptionsLoading, setIsOptionsLoading] = useState(true);
//   const [editUserData, setEditUserData] = useState(null);
//   const [selectedRole, setSelectedRole] = useState("");
//   const [formSubmitted, setFormSubmitted] = useState(false);
//   const [originalZones, setOriginalZones] = useState([]);
//   const [circles, setCircles] = useState([]);
//   const [wards, setWards] = useState([]);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [zones, setZones] = useState([]);
//   const [selectedZones, setSelectedZones] = useState({});
//   const [circleOptions, setCircleOptions] = useState([]);
//   const [wardOptions, setWardOptions] = useState([]);
//   const [isCirclesEnabled, setIsCirclesEnabled] = useState(false);
//   const [isWardsEnabled, setIsWardsEnabled] = useState(false);
//   const [isCirclesDropdownOpen, setIsCirclesDropdownOpen] = useState(false);
//   const [isWardsDropdownOpen, setIsWardsDropdownOpen] = useState(false);
//   const [selectedCircles, setSelectedCircles] = useState({});
//   const [isInputValid, setIsInputValid] = useState(true);
//   const [canToggleSwitch, setCanToggleSwitch] = useState(false);
//   const [isToggleEnabled, setIsToggleEnabled] = useState(false);
//   const [isSwitchEnabled, setIsSwitchEnabled] = useState(false);
//   const [zonesSelected, setZonesSelected] = useState(false);
//   const [error, setError] = useState(null);
//   const [password, setPassword] = useState("");
//   const [filterOriginalUsersData, setFilterOriginalUsersData] = useState([]);
//   const initialFormInput = {
//     userName: "",
//     employeeCode: "",
//     password: "",
//     isEmployee: "",
//     emailId: "",
//     mobileNumber: "",
//     roleId: "",
//     zoneId: "",
//     zoneIds: [],
//     circleIds: [],
//     wardIds: [],
//     isActive: false,
//   };
//   const [formInput, setFormInput] = useState(initialFormInput);

//   const [showPassword, setShowPassword] = useState(false);
//   const [passwordshow, setPasswordShow] = useState(false);
//   const [associatedTransferStationData, setAssociatedTransferStationData] = useState([]);

//   const handleTogglePassword = () => {
//     setShowPassword(!showPassword);
//   };

//   const handlePasswordToggle = () => {
//     setPasswordShow(!passwordshow);
//   };

//   useEffect(() => {
//     setFormInput((prevData) => ({
//       ...prevData,
//       password: "",
//     }));
//   }, []);

//   const handleShow = () => {
//     setLgShow(true);
//     setIsOptionsLoading(true);
//     setFormSubmitted(false);
//     setTimeout(() => {
//       setIsOptionsLoading(false);
//     }, 1000);
//     setEditUserData(null);
//     setFormInput({
//       userName: "",
//       employeeCode: "",
//       password: "",
//       isEmployee: true,
//       emailId: "",
//       mobileNumber: "",
//       roleId: "",
//       zoneId: "",
//       circleId: "",
//       wardId: "",
//       zoneIds: [],
//       circleIds: [],
//       wardIds: [],
//       isActive: true,
//     });
//     setSelectedZones({});
//     setWardOptions([]);
//     setCircleOptions([]);
//     setOptions([]);
//   };

//   const handleClose = () => {
//     setLgShow(false);
//     setFormSubmitted(false);
//     if (editUserData) {
//       setEditUserData(editUserData);
//       setFormInput((prevInput) => ({
//         ...prevInput,
//       }));
//     } else {
//       setEditUserData(null);
//       setFormInput({
//         userName: "",
//         employeeCode: "",
//         isEmployee: true,
//         emailId: "",
//         mobileNumber: "",
//         roleId: "",
//         zoneIds: [],
//         circleIds: [],
//         wardIds: [],
//         isActive: true,
//         password: "",
//       });
//       setSelectedZones({});
//       setWardOptions([]);
//       setCircleOptions([]);
//       setOptions([]);
//     }
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const data = await GetAllRoles();
//         const sortedRoles = data.sort((a, b) => {
//           if (a.isActive === b.isActive) {
//             return 0;
//           }
//           return a.isActive ? -1 : 1;
//         });
//         setRole(data);
//       } catch (error) {
//         console.error("Error fetching roles:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const data = await GetZone();
//       if (data === null) {
//         setZones([]);
//       } else {
//         const sortedZoneData = data.sort((a, b) =>
//           a.isActive === b.isActive ? 0 : a.isActive ? -1 : 1
//         );
//         setZones(sortedZoneData);
//         setIsOptionsLoading(false);
//       }
//     } catch (error) {
//       console.error("Error fetching zones:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     fetchCircles();
//   }, []);

//   const handleCheckboxChange = async (zoneId) => {
//     const updatedSelectedZones = {
//       ...selectedZones,
//       [zoneId]: !selectedZones[zoneId],
//     };
//     setSelectedZones(updatedSelectedZones);

//     const selectedZoneIds = Object.keys(updatedSelectedZones).filter(
//       (id) => updatedSelectedZones[id]
//     );

//     setFormInput((prevData) => ({
//       ...prevData,
//       zoneIds: selectedZoneIds,
//     }));

//     if (selectedZoneIds.length > 0) {
//       setIsCirclesEnabled(true);
//       setIsToggleEnabled(true);

//       try {
//         const circlesData = await GetCircleByMultipleZoneId(selectedZoneIds);
//         const formattedCircles = circlesData.flatMap((zone) =>
//           zone.circles.map((circle) => ({
//             value: circle.circleId,
//             label: circle.circleName,
//           }))
//         );

//         // Filter existing circleIds to keep only those that are still valid
//         const validCircleIds = formInput.circleIds.filter((circleId) =>
//           formattedCircles.some((circle) => circle.value === circleId)
//         );

//         setOptions(formattedCircles);
//         setCircleOptions(formattedCircles);
//         setCircles(circlesData);

//         // Update formInput with valid circleIds
//         setFormInput((prevData) => ({
//           ...prevData,
//           circleIds: validCircleIds,
//         }));

//         // Fetch wards for the valid circleIds
//         if (validCircleIds.length > 0) {
//           const wardsData = await GetWardByMultipleCircleId(validCircleIds);
//           const formattedWards = wardsData.flatMap((circle) =>
//             Array.isArray(circle.wards)
//               ? circle.wards.map((ward) => ({
//                   value: ward.wardId,
//                   label: ward.wardName,
//                 }))
//               : []
//           );

//           // Filter existing wardIds to keep only those that are still valid
//           const validWardIds = formInput.wardIds.filter((wardId) =>
//             formattedWards.some((ward) => ward.value === wardId)
//           );

//           setWardOptions([
//             { value: "select-all", label: "Select All" },
//             ...formattedWards,
//           ]);
//           setIsWardsEnabled(true);

//           setFormInput((prevData) => ({
//             ...prevData,
//             wardIds: validWardIds,
//           }));
//         } else {
//           setWardOptions([]);
//           setIsWardsEnabled(false);
//           setFormInput((prevData) => ({
//             ...prevData,
//             wardIds: [],
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching circles or wards:", error);
//         toast.error("Failed to load circles or wards");
//       }
//     } else {
//       setOptions([]);
//       setCircleOptions([]);
//       setWardOptions([]);
//       setIsCirclesEnabled(false);
//       setIsToggleEnabled(false);
//       setIsCirclesDropdownOpen(false);
//       setIsWardsEnabled(false);
//       setFormInput((prevInput) => ({
//         ...prevInput,
//         circleIds: [],
//         wardIds: [],
//       }));
//     }
//   };

//   const fetchCircles = async () => {
//     try {
//       const selectedZoneIds = Object.keys(selectedZones).filter(
//         (zoneId) => selectedZones[zoneId]
//       );
//       if (selectedZoneIds.length > 0) {
//         const data = await GetCirclebyID({ zoneIds: selectedZoneIds });
//         setCircles(data);
//       } else {
//         setCircles([]);
//       }
//     } catch (error) {
//       console.error("Error fetching circles:", error);
//     }
//   };

//   const fetchUsers = async () => {
//     try {
//       const data = await GetAllUsers();
//       const userDataResponse = data.map((user) => ({
//         ...user,
//         status: user.isActive ? "Active" : "InActive",
//       }));

//       const sortedUserData = userDataResponse.sort((a, b) => {
//         if (a.isActive === b.isActive) {
//           return 0;
//         }
//         return a.isActive ? -1 : 1;
//       });

//       setUsers(sortedUserData);
//       setFilterOriginalUsersData(sortedUserData);
//       setIsOptionsLoading(false);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//       setIsOptionsLoading(false);
//     }
//   };

//   const fetchCirclesByMultipleZones = async () => {
//     try {
//       const zoneIds = Object.keys(selectedZones).filter(
//         (zoneId) => selectedZones[zoneId]
//       );

//       if (zoneIds.length > 0) {
//         const data = await GetCircleByMultipleZoneId(zoneIds);

//         if (Array.isArray(data)) {
//           const formattedOptions = data.flatMap((zone) =>
//             Array.isArray(zone.circles)
//               ? zone.circles.map((circle) => ({
//                   value: circle.circleId,
//                   label: circle.circleName,
//                 }))
//               : []
//           );

//           // Filter existing circleIds to keep only those that are still valid
//           const validCircleIds = formInput.circleIds.filter((circleId) =>
//             formattedOptions.some((circle) => circle.value === circleId)
//           );

//           setOptions(formattedOptions);
//           setCircleOptions(formattedOptions);
//           setCircles(data);

//           setFormInput((prevData) => ({
//             ...prevData,
//             circleIds: validCircleIds,
//           }));

//           // Fetch wards for the valid circleIds
//           if (validCircleIds.length > 0) {
//             const wardsData = await GetWardByMultipleCircleId(validCircleIds);
//             const formattedWards = wardsData.flatMap((circle) =>
//               Array.isArray(circle.wards)
//                 ? circle.wards.map((ward) => ({
//                     value: ward.wardId,
//                     label: ward.wardName,
//                   }))
//                 : []
//             );

//             // Filter existing wardIds to keep only those that are still valid
//             const validWardIds = formInput.wardIds.filter((wardId) =>
//               formattedWards.some((ward) => ward.value === wardId)
//             );

//             setWardOptions([
//               { value: "select-all", label: "Select All" },
//               ...formattedWards,
//             ]);
//             setIsWardsEnabled(true);

//             setFormInput((prevData) => ({
//               ...prevData,
//               wardIds: validWardIds,
//             }));
//           } else {
//             setWardOptions([]);
//             setIsWardsEnabled(false);
//             setFormInput((prevData) => ({
//               ...prevData,
//               wardIds: [],
//             }));
//           }
//         } else {
//           console.error("Unexpected data format:", data);
//           setOptions([]);
//           setCircleOptions([]);
//           setWardOptions([]);
//           setFormInput((prevData) => ({
//             ...prevData,
//             circleIds: [],
//             wardIds: [],
//           }));
//         }
//       } else {
//         setOptions([]);
//         setCircleOptions([]);
//         setWardOptions([]);
//         setFormInput((prevData) => ({
//           ...prevData,
//           circleIds: [],
//           wardIds: [],
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching circles or wards:", error);
//       toast.error("Failed to load circles or wards");
//       setOptions([]);
//       setCircleOptions([]);
//       setWardOptions([]);
//       setFormInput((prevData) => ({
//         ...prevData,
//         circleIds: [],
//         wardIds: [],
//       }));
//     }
//   };

//   useEffect(() => {
//     fetchCirclesByMultipleZones();
//   }, [selectedZones]);

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const handleEmployeeChange = (e) => {
//     const { name, value } = e.target;
//     setFormInput((prevData) => ({
//       ...prevData,
//       [name]: value === "true" ? true : false,
//     }));
//   };

//   const handleAddUser = () => {
//     setEditUserData(null);
//     setFormInput(initialFormInput);
//     setSelectedZones({});
//     setCircleOptions([]);
//     setWardOptions([]);
//     setOptions([]);
//     setLgShow(true);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setFormSubmitted(true);

//     try {
//       setIsOptionsLoading(true);

//       const {
//         userName,
//         employeeCode,
//         password,
//         isEmployee,
//         emailId,
//         mobileNumber,
//         roleId,
//         zoneIds,
//         circleIds,
//         // wardIds,
//         isActive,
//       } = formInput;

//       const requiredFields = editUserData
//         ? [userName, employeeCode, emailId, mobileNumber, roleId]
//         : [userName, employeeCode, password, emailId, mobileNumber, roleId];

//       if (requiredFields.some((field) => !field)) {
//         console.error("Please fill all the required fields");
//         setIsOptionsLoading(false);
//         return;
//       }

//       const userData = {
//         userName,
//         employeeCode,
//         isEmployee,
//         emailId,
//         mobileNumber,
//         roleId,
//         zoneIds: zoneIds.length ? zoneIds : [],
//         circleIds: circleIds.length ? circleIds : [],
//         // wardIds: wardIds.length ? wardIds : [],
//         isActive,
//       };

//       if (editUserData) {
//         userData.userId = editUserData.userId;
//         if (password?.length > 0) {
//           await UpdatePassword(userData.userId, password);
//         }
//         await UpdateUsers(userData);
//         toast.success("User updated successfully!");

//         setUsers(
//           users.map((user) =>
//             user.userId === userData.userId ? { ...user, ...userData } : user
//           )
//         );
//       } else {
//         userData.password = password;
//         const response = await CreateUsers(userData);
//         if (response.status === 200) {
//           setUsers([...users, response]);
//           toast.success("User added successfully!");
//         }
//       }

//       fetchUsers();
//       handleClose();
//     } catch (xhr) {
//       if (xhr && xhr.response && typeof xhr.response.data.errors === "object") {
//         const formErrors = {};
//         Object.keys(xhr.response.data.errors).forEach((key) => {
//           if (
//             Array.isArray(xhr.response.data.errors[key]) &&
//             xhr.response.data.errors[key].length > 0
//           ) {
//             formErrors[key] = xhr.response.data.errors[key][0];
//             toast.error(`${key}: ${xhr.response.data.errors[key][0]}`);
//           }
//         });
//       } else {
//         toast.error(xhr.response?.data);
//       }
//     } finally {
//       setIsOptionsLoading(false);
//     }
//   };

//   const handleStatusChange = (e) => {
//     const { name, value } = e.target;
//     setFormInput((prevData) => ({
//       ...prevData,
//       [name]: value === "true" ? true : false,
//     }));
//   };

//   const handleEditUser = async (selectedUser) => {
//     if (!selectedUser) {
//       console.error("No user data provided for editing.");
//       return;
//     }

//     setEditUserData(selectedUser);
//     setIsEditMode(true);
//     setLgShow(true);
//     setIsOptionsLoading(true);

//     // Set selected zones
//     const updatedZones = {};
//     selectedUser?.zoneIds?.forEach((zoneId) => {
//       updatedZones[zoneId] = true;
//     });
//     setSelectedZones(updatedZones);

//     // Set form input with user data
//     const activeRole = role.filter(
//       (role) => role.roleId === selectedUser?.roleId && role.isActive
//     );
//     setFormInput({
//       userName: selectedUser?.userName || "",
//       employeeCode: selectedUser?.employeeCode || "",
//       password: "",
//       isEmployee: selectedUser?.isEmployee ?? true,
//       emailId: selectedUser?.emailId || "",
//       mobileNumber: selectedUser?.mobileNumber || "",
//       roleId: activeRole.length ? selectedUser?.roleId : "",
//       zoneIds: selectedUser?.zoneIds || [],
//       circleIds: selectedUser?.circleIds || [],
//       wardIds: selectedUser?.wardIds || [],
//       isActive: selectedUser?.isActive ?? false,
//     });

//     try {
//       // Fetch circles for the user's zoneIds
//       if (selectedUser?.zoneIds?.length > 0) {
//         const circlesData = await GetCircleByMultipleZoneId(selectedUser.zoneIds);
//         const formattedCircles = circlesData.flatMap((zone) =>
//           zone.circles.map((circle) => ({
//             value: circle.circleId,
//             label: circle.circleName,
//           }))
//         );
//         setOptions(formattedCircles);
//         setCircleOptions(formattedCircles);
//         setCircles(circlesData);
//         setIsCirclesEnabled(true);

//         // Fetch wards for the user's circleIds
//         if (selectedUser?.circleIds?.length > 0) {
//           const wardsData = await GetWardByMultipleCircleId(selectedUser.circleIds);
//           const formattedWards = wardsData.flatMap((circle) =>
//             Array.isArray(circle.wards)
//               ? circle.wards.map((ward) => ({
//                   value: ward.wardId,
//                   label: ward.wardName,
//                 }))
//               : []
//           );
//           setWardOptions([
//             { value: "select-all", label: "Select All" },
//             ...formattedWards,
//           ]);
//           setIsWardsEnabled(true);
//         } else {
//           setWardOptions([]);
//           setIsWardsEnabled(false);
//         }
//       } else {
//         setOptions([]);
//         setCircleOptions([]);
//         setWardOptions([]);
//         setIsCirclesEnabled(false);
//         setIsWardsEnabled(false);
//       }
//     } catch (error) {
//       console.error("Error fetching circles or wards:", error);
//       toast.error("Failed to load circles or wards");
//     } finally {
//       setIsOptionsLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     let sanitizedValue = value;

//     if (name === "mobileNumber") {
//       sanitizedValue = value.replace(/\D/g, "").slice(0, 10);

//       if (sanitizedValue.length > 0 && !/^[6789]/.test(sanitizedValue)) {
//         console.error("Mobile number must start with 6, 7, 8, or 9");
//       }
//     } else if (name === "userName" || name === "employeeCode") {
//       sanitizedValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
//     }

//     setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
//   };

//   const handleMobilenumberChange = (e) => {
//     const { name, value } = e.target;
//     const numberRegex = /^[0-9]*$/;
//     if (value === "" || (numberRegex.test(value) && value.length <= 10)) {
//       setFormInput({ ...formInput, [name]: value });
//     }
//   };

//   const handleEmailChange = (e) => {
//     const { name, value } = e.target;
//     const alphabetsOnlyRegex = /^[0-9]*$/;
//     if (
//       (value === "" || alphabetsOnlyRegex.test(value)) &&
//       value.length <= 10
//     ) {
//       setFormInput({ ...formInput, [name]: value });
//     }
//   };

//   let storedPermissions = localStorage.getItem("permissionId");
//   const permissionValues1 =
//     JSON.parse(localStorage.getItem("rolePermissions")) || {};
//   let canWriteValue = null;

//   storedPermissions = parseInt(storedPermissions, 10);

//   const matchingPermission = permissionValues1.find(
//     (mapping) => mapping.permissionId === storedPermissions
//   );

//   if (matchingPermission) {
//     canWriteValue = matchingPermission.canWrite;
//   } else {
//     console.log(`No match found for permission ID ${storedPermissions}`);
//   }

//   useEffect(() => {
//     const fetchCirclesBySelectedZones = async () => {
//       try {
//         const zoneIds = Object.keys(selectedZones).filter(
//           (zoneId) => selectedZones[zoneId]
//         );

//         if (zoneIds.length > 0) {
//           const data = await GetCircleByMultipleZoneId(zoneIds);

//           if (Array.isArray(data)) {
//             const formattedCircleOptions = data.flatMap((zone) =>
//               zone.circles.map((circle) => ({
//                 value: circle.circleId,
//                 label: circle.circleName,
//               }))
//             );

//             // Filter existing circleIds to keep only those that are still valid
//             const validCircleIds = formInput.circleIds.filter((circleId) =>
//               formattedCircleOptions.some((circle) => circle.value === circleId)
//             );

//             setCircleOptions(formattedCircleOptions);
//             setOptions(formattedCircleOptions);
//             setCircles(data);

//             setFormInput((prevData) => ({
//               ...prevData,
//               circleIds: validCircleIds,
//             }));

//             // Fetch wards for the valid circleIds
//             if (validCircleIds.length > 0) {
//               const wardsData = await GetWardByMultipleCircleId(validCircleIds);
//               const formattedWards = wardsData.flatMap((circle) =>
//                 Array.isArray(circle.wards)
//                   ? circle.wards.map((ward) => ({
//                       value: ward.wardId,
//                       label: ward.wardName,
//                     }))
//                   : []
//               );

//               // Filter existing wardIds to keep only those that are still valid
//               const validWardIds = formInput.wardIds.filter((wardId) =>
//                 formattedWards.some((ward) => ward.value === wardId)
//               );

//               setWardOptions([
//                 { value: "select-all", label: "Select All" },
//                 ...formattedWards,
//               ]);
//               setIsWardsEnabled(true);

//               setFormInput((prevData) => ({
//                 ...prevData,
//                 wardIds: validWardIds,
//               }));
//             } else {
//               setWardOptions([]);
//               setIsWardsEnabled(false);
//               setFormInput((prevData) => ({
//                 ...prevData,
//                 wardIds: [],
//               }));
//             }
//           } else {
//             console.error("Unexpected data format:", data);
//             setCircleOptions([]);
//             setOptions([]);
//             setWardOptions([]);
//             setFormInput((prevData) => ({
//               ...prevData,
//               circleIds: [],
//               wardIds: [],
//             }));
//           }
//         } else {
//           setCircleOptions([]);
//           setOptions([]);
//           setWardOptions([]);
//           setFormInput((prevData) => ({
//             ...prevData,
//             circleIds: [],
//             wardIds: [],
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching circles or wards:", error);
//         toast.error("Failed to load circles or wards");
//         setCircleOptions([]);
//         setOptions([]);
//         setWardOptions([]);
//         setFormInput((prevData) => ({
//           ...prevData,
//           circleIds: [],
//           wardIds: [],
//         }));
//       }
//     };

//     fetchCirclesBySelectedZones();
//   }, [selectedZones]);

//   useEffect(() => {
//     const anyZoneSelected = Object.values(selectedZones).some(
//       (isSelected) => isSelected
//     );

//     setCanToggleSwitch(anyZoneSelected);
//     setIsCirclesEnabled(anyZoneSelected);

//     if (!anyZoneSelected) {
//       setIsDropdownOpen(false);
//       setIsCirclesDropdownOpen(false);
//       setIsWardsEnabled(false);
//     }
//   }, [selectedZones]);

//   useEffect(() => {
//     const anyZoneSelected = Object.values(selectedZones).some(
//       (isSelected) => isSelected
//     );
//     setIsSwitchEnabled(anyZoneSelected);

//     if (!anyZoneSelected) {
//       setIsDropdownOpen(false);
//     }
//   }, [selectedZones]);

//   const handleWardChange = async (selectedOptions) => {
//     let selectedValues = [];

//     if (selectedOptions && selectedOptions.some((option) => option.value === "select-all")) {
//       const allWards = wardOptions.filter((option) => option.value !== "select-all");
//       selectedValues = allWards.map((option) => option.value);
//     } else {
//       selectedValues = Array.isArray(selectedOptions)
//         ? selectedOptions.map((option) => option.value)
//         : selectedOptions
//         ? [selectedOptions.value]
//         : [];
//     }

//     setFormInput((prevState) => ({
//       ...prevState,
//       wardIds: selectedValues,
//     }));

//     setIsInputValid(selectedValues.length > 0 || !formSubmitted);
//   };

//   const handleCircleChange = async (selectedOptions) => {
//     let selectedValues = [];

//     if (selectedOptions && selectedOptions.some((option) => option.value === "select-all")) {
//       const allCircles = options.filter((option) => option.value !== "select-all");
//       selectedValues = allCircles.map((option) => option.value);
//     } else {
//       selectedValues = Array.isArray(selectedOptions)
//         ? selectedOptions.map((option) => option.value)
//         : selectedOptions
//         ? [selectedOptions.value]
//         : [];
//     }

//     setFormInput((prevState) => ({
//       ...prevState,
//       circleIds: selectedValues,
//     }));

//     setIsInputValid(selectedValues.length > 0 || !formSubmitted);

//     // Fetch wards for the new circleIds
//     try {
//       if (selectedValues.length > 0) {
//         const wardsData = await GetWardByMultipleCircleId(selectedValues);
//         const formattedWards = wardsData.flatMap((circle) =>
//           Array.isArray(circle.wards)
//             ? circle.wards.map((ward) => ({
//                 value: ward.wardId,
//                 label: ward.wardName,
//               }))
//             : []
//         );

//         // Filter existing wardIds to keep only those that are still valid
//         const validWardIds = formInput.wardIds.filter((wardId) =>
//           formattedWards.some((ward) => ward.value === wardId)
//         );

//         setWardOptions([
//           { value: "select-all", label: "Select All" },
//           ...formattedWards,
//         ]);
//         setIsWardsEnabled(true);

//         setFormInput((prevData) => ({
//           ...prevData,
//           wardIds: validWardIds,
//         }));
//       } else {
//         setWardOptions([]);
//         setIsWardsEnabled(false);
//         setFormInput((prevData) => ({
//           ...prevData,
//           wardIds: [],
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching wards:", error);
//       toast.error("Failed to load wards");
//       setWardOptions([]);
//       setIsWardsEnabled(false);
//       setFormInput((prevData) => ({
//         ...prevData,
//         wardIds: [],
//       }));
//     }
//   };

//   const handleCirclesDropdownOpen = () => {
//     if (isCirclesEnabled) {
//       setIsCirclesDropdownOpen((prevState) => !prevState);
//     }
//   };

//   const handleWardsDropdownOpen = () => {
//     if (isWardsEnabled) {
//       setIsWardsDropdownOpen((prevState) => !prevState);
//     }
//   };

//   const handleDropdownClose = () => {
//     setIsCirclesDropdownOpen(false);
//     setIsWardsDropdownOpen(false);
//   };

//   useEffect(() => {
//     const fetchWardsBySelectedCircles = async () => {
//       try {
//         const circleIds = formInput.circleIds;

//         if (circleIds && circleIds.length > 0) {
//           const data = await GetWardByMultipleCircleId(circleIds);

//           if (Array.isArray(data)) {
//             const formattedWardOptions = data.flatMap((circle) =>
//               Array.isArray(circle.wards)
//                 ? circle.wards.map((ward) => ({
//                     value: ward.wardId,
//                     label: ward.wardName,
//                   }))
//                 : []
//             );

//             // Filter existing wardIds to keep only those that are still valid
//             const validWardIds = formInput.wardIds.filter((wardId) =>
//               formattedWardOptions.some((ward) => ward.value === wardId)
//             );

//             setWardOptions([
//               { value: "select-all", label: "Select All" },
//               ...formattedWardOptions,
//             ]);
//             setIsWardsEnabled(true);

//             setFormInput((prevData) => ({
//               ...prevData,
//               wardIds: validWardIds,
//             }));
//           } else {
//             console.error("Unexpected data format:", data);
//             setWardOptions([]);
//             setIsWardsEnabled(false);
//             setFormInput((prevData) => ({
//               ...prevData,
//               wardIds: [],
//             }));
//           }
//         } else {
//           setWardOptions([]);
//           setIsWardsEnabled(false);
//           setFormInput((prevData) => ({
//             ...prevData,
//             wardIds: [],
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching wards:", error);
//         toast.error("Failed to load wards");
//         setWardOptions([]);
//         setIsWardsEnabled(false);
//         setFormInput((prevData) => ({
//           ...prevData,
//           wardIds: [],
//         }));
//       }
//     };

//     fetchWardsBySelectedCircles();
//   }, [formInput.circleIds]);

//   useEffect(() => {
//     if (formInput.circleIds?.length > 0) {
//       setIsWardsEnabled(true);
//     } else {
//       setWardOptions([]);
//       setIsWardsEnabled(false);
//       setFormInput((prevData) => ({
//         ...prevData,
//         wardIds: [],
//       }));
//     }
//   }, [formInput.circleIds]);

//   const searchZoneHandler = (e) => {
//     const term = e.target.value.toLowerCase();
//     const data = filterOriginalUsersData.filter((item) =>
//       item?.userName?.toLowerCase()?.includes(term) ||
//       item?.mobileNumber?.toLowerCase()?.includes(term)
//     );
//     setUsers(data);
//   };

//   const circleOptionsWithSelectAll = [
//     { value: "select-all", label: "Select All" },
//     ...options,
//   ];

//   const usersColumns = [
//     {
//       label: "User Name",
//       field: "userName",
//     },
//     {
//       label: "Employee Code",
//       field: "employeeCode",
//     },
//     {
//       label: "Email",
//       field: "emailId",
//     },
//     {
//       label: "Mobile No.",
//       field: "mobileNumber",
//     },
//     {
//       label: "Status",
//       field: "status",
//     },
//     {
//       label: "Action",
//       render: (row) => (
//         <button
//           className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
//           onClick={() => {
//             handleEditUser(row);
//             setLgShow(true);
//           }}
//         >
//           <FontAwesomeIcon icon={faEdit} />
//         </button>
//       ),
//     },
//   ];

//   return (
//     <>
//       <div style={{ width: "100%" }}>
//         <div className="content">
//           <div className="page-content">
//             <div className="row mt-3 align-items-center justify-content-between">
//               <div className="col-md-3">
//                 <div className="form-group mb-0">
//                   <input
//                     placeholder="Search Username"
//                     type="text"
//                     className="form-control bg-white"
//                     onInput={searchZoneHandler}
//                   />
//                 </div>
//               </div>
//               <div className="col-md-3 d-flex justify-content-end">
//                 <div>
//                   {canWriteValue === true ? (
//                     <button
//                       className="button-container ms-auto mr-1"
//                       onClick={handleShow}
//                     >
//                       <i className="fa-solid fa-plus me-1 icon-container"></i>
//                       {t("Add User")}
//                     </button>
//                   ) : (
//                     ""
//                   )}
//                 </div>
//                 <div>
//                   <ExportUsersExcel filteredData={users} />
//                 </div>
//               </div>
//             </div>
//             <div className="card mt-3">
//               <div className="card-body p-3">
//                 <div className="top-header">
//                   <span>{t("Users")}</span>
//                 </div>
//                 <MUITable loading={isLoading}
//                   needSRNumber
//                   columns={usersColumns}
//                   rows={users}
//                   tableHeight={500}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {isOptionsLoading && <TableLoader height={500} />}
//       <Modal
//         centered
//         size="lg"
//         show={lgShow}
//         onHide={() => setLgShow(false)}
//         backdrop="static"
//       >
//         <Modal.Header>
//           <Modal.Title id="example-modal-sizes-title-lg">
//             {editUserData ? t("Edit User") : t("Add User")}
//           </Modal.Title>
//           <i
//             className="fa-solid fa-xmark close-container"
//             onClick={handleClose}
//           ></i>
//         </Modal.Header>
//         <hr />
//         <Modal.Body>
//           <form onSubmit={handleSubmit}>
//             <div className="row">
//               <div className="col-md-4 mb-3">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Employee Code
//                     <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="employeeCode"
//                     placeholder="Enter Emp Code"
//                     className={`form-control ${formInput.employeeCode || !formSubmitted ? "" : "input-error"}`}
//                     onChange={handleInputChange}
//                     value={formInput.employeeCode}
//                     maxLength={8}
                    // disabled={!canWriteValue}
//                   />
//                   {!formInput.employeeCode && formSubmitted && (
//                     <div className="required-message">
//                       Employee Code is Required
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-4 mb-3">
//                 <div className="form-group">
//                   <label className="form-label">
//                     User Name
//                     <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="userName"
//                     placeholder="Enter User Name"
//                     className={`form-control ${formInput.userName || !formSubmitted ? "" : "input-error"}`}
//                     value={formInput.userName}
//                     onChange={handleInputChange}
//                     maxLength={42}
//                     disabled={!canWriteValue}
//                   />
//                   {!formInput.userName && formSubmitted && (
//                     <div className="required-message">
//                       User Name is Required
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className="col-md-4 mb-3">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Role Name
//                     <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
//                   </label>
//                   <select
//                     className={`form-select ${formInput.roleId || !formSubmitted ? "" : "input-error"}`}
//                     name="roleId"
//                     value={formInput.roleId}
//                     onChange={handleInputChange}
//                     disabled={!canWriteValue}
//                   >
//                     <option value="">Select</option>
//                     {role
//                       .filter((role) => role.isActive)
//                       .map((role) => (
//                         <option key={role.roleId} value={role.roleId}>
//                           {role.roleName}
//                         </option>
//                       ))}
//                   </select>
//                   {!formInput.roleId && formSubmitted && (
//                     <div className="required-message">
//                       Role Name is Required
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-4 mb-3">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Email ID
//                     <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
//                   </label>
//                   <input
//                     type="email"
//                     name="emailId"
//                     placeholder="Enter Email ID"
//                     className={`form-control ${formInput.emailId || !formSubmitted ? "" : "input-error"}`}
//                     onChange={handleInputChange}
//                     value={formInput.emailId}
//                     disabled={!canWriteValue}
//                   />
//                   {!formInput.emailId && formSubmitted && (
//                     <div className="required-message">Email ID is Required</div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-4 mb-3">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Mobile Number
//                     <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
//                   </label>
//                   <input
//                     name="mobileNumber"
//                     placeholder="Enter Mobile Number"
//                     pattern="[0-9]{10}"
//                     title="Mobile number must be exactly 10 digits long."
//                     className={`form-control ${formInput.mobileNumber || !formSubmitted ? "" : "input-error"}`}
//                     onChange={handleMobilenumberChange}
//                     value={formInput.mobileNumber}
//                     disabled={!canWriteValue}
//                   />
//                   {!formInput.mobileNumber && formSubmitted && (
//                     <div className="required-message">
//                       Mobile Number is Required
//                     </div>
//                   )}
//                   {formInput.mobileNumber &&
//                     formInput.mobileNumber.length !== 10 &&
//                     formSubmitted && (
//                       <div className="required-message">
//                         Please enter 10 numbers
//                       </div>
//                     )}
//                 </div>
//               </div>
//               {editUserData ? (
//                 <div className="col-md-4 mb-3">
//                   <div className="form-group">
//                     <label className="form-label">Change Password</label>
//                     <div className="input-group">
//                       <input
//                         type={passwordshow ? "text" : "password"}
//                         name="password"
//                         id="passwordInput"
//                         placeholder="Enter New Password"
//                         maxLength={18}
//                         className="form-control"
//                         value={formInput.password}
//                         autoComplete="new-password"
//                         onChange={handleInputChange}
//                         disabled={!canWriteValue}
//                       />
//                       <div className="input-group-append">
//                         <span
//                           className="input-group-text"
//                           onClick={handlePasswordToggle}
//                           style={{ cursor: "pointer" }}
//                         >
//                           <FontAwesomeIcon
//                             icon={passwordshow ? faEye : faEyeSlash}
//                           />
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="col-md-4 mb-3">
//                   <div className="form-group">
//                     <label className="form-label">
//                       Password <span style={{ color: "#EC1117" }}>*</span>
//                     </label>
//                     <div className="input-group">
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         name="password"
//                         id="passwordInput"
//                         placeholder="Enter Password"
//                         maxLength={18}
//                         className={`form-control ${formInput.password || !formSubmitted ? "" : "input-error"}`}
//                         value={formInput.password}
//                         onChange={handleInputChange}
//                         autoComplete="new-password"
//                         disabled={!canWriteValue}
//                       />
//                       <div className="input-group-append">
//                         <span
//                           className="input-group-text"
//                           onClick={handleTogglePassword}
//                           style={{ cursor: "pointer" }}
//                         >
//                           <FontAwesomeIcon
//                             icon={showPassword ? faEye : faEyeSlash}
//                           />
//                         </span>
//                       </div>
//                     </div>
//                     {!formInput.password && formSubmitted && (
//                       <div className="required-message">
//                         Password is Required
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}

//               <div className="col-md-12 mb-3">
//                 <div className="form-label">Select Zones</div>
//                 <div className="form-check">
//                   <div className="form-group" style={{ display: "flex" }}>
//                     {isOptionsLoading ? (
//                       <p>Loading zones...</p>
//                     ) : zones.length > 0 ? (
//                       <form className="d-flex gap-4 ">
//                         {zones.map((zone) => (
//                           <span key={zone.zoneId} >
//                             <label>
//                               <input
//                                 type="checkbox"
//                                 className="form-check-input"
//                                 value={formInput.zoneIds}
//                                 checked={selectedZones[zone.zoneId] || false}
//                                 onChange={() => handleCheckboxChange(zone.zoneId)}
//                               />
//                               {zone.zoneName}
//                             </label>
//                           </span>
//                         ))}
//                       </form>
//                     ) : (
//                       <p>No zones available</p>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               <div className="row">
//                 <div className="col-md-6">
//                   <div className="row align-items-end">
//                     <div className="col-md-2">
//                       <div className="form-group">
//                         <span
//                           className="form"
//                           style={{
//                             transform: isCirclesEnabled ? "translateX(14px)" : "translateX(0)",
//                             backgroundColor: isCirclesEnabled ? "#2196F3" : "#ccc",
//                           }}
//                         ></span>
//                       </div>
//                     </div>

//                     <div className="col-md-10">
//                       <div className="form-group">
//                         <label className="form-label">Wards</label>
//                         <div className="select-container" onClick={handleCirclesDropdownOpen}>
//                           <Select
//                             classNamePrefix="CreatableSelect"
//                             className={`select-component ${!formInput.circleIds?.length && formSubmitted ? "input-error" : ""}`}
//                             id="circleIds"
//                             name="circleIds"
//                             value={circleOptionsWithSelectAll.filter((option) =>
//                               formInput.circleIds?.includes(option.value) && option.value !== "select-all"
//                             )}
//                             onChange={handleCircleChange}
//                             isMulti
//                             options={circleOptionsWithSelectAll}
//                             isDisabled={!isCirclesEnabled}
//                             menuIsOpen={isCirclesDropdownOpen}
//                             onMenuClose={handleDropdownClose}
//                             isLoading={isOptionsLoading}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* <div className="col-md-6">
//                   <div className="row align-items-end">
//                     <div className="col-md-2">
//                       <div className="form-group">
//                         <span
//                           className="form"
//                           style={{
//                             transform: isWardsEnabled ? "translateX(14px)" : "translateX(0)",
//                             backgroundColor: isWardsEnabled ? "#2196F3" : "#ccc",
//                           }}
//                         ></span>
//                       </div>
//                     </div>
//                     <div className="col-md-10">
//                       <div className="form-group">
//                         <label className="form-label">Wards</label>
//                         <div className="select-container" onClick={handleWardsDropdownOpen}>
//                           <Select
//                             classNamePrefix="CreatableSelect"
//                             className={`select-component ${!formInput.wardIds?.length && formSubmitted ? "input-error" : ""}`}
//                             id="wardIds"
//                             name="wardIds"
//                             value={wardOptions.filter((wardOption) =>
//                               formInput.wardIds?.includes(wardOption.value) && wardOption.value !== "select-all"
//                             )}
//                             onChange={handleWardChange}
//                             isMulti
//                             options={wardOptions}
//                             isDisabled={!isWardsEnabled}
//                             menuIsOpen={isWardsDropdownOpen}
//                             onMenuClose={handleDropdownClose}
//                             placeholder="Select Wards"
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div> */}
//               </div>

//               <div className="col-md-4">
//                 <label className="form-label">
//                   Is Employee<span style={{ color: "#EC1117" }}>*</span>
//                 </label>
//                 <div className="form-group" style={{ display: "flex" }}>
//                   <div className="form-check">
//                     <input
//                       type="radio"
//                       className="form-check-input"
//                       name="isEmployee"
//                       id="activeEmployee"
//                       value="true"
//                       checked={formInput.isEmployee === true}
//                       onChange={handleEmployeeChange}
//                       color="#EC1117"
//                     />
//                     <label className="form-check-label" htmlFor="activeEmployee">
//                       Yes
//                     </label>
//                   </div>
//                   <div className="form-check" style={{ marginLeft: "60px" }}>
//                     <input
//                       type="radio"
//                       className="form-check-input"
//                       name="isEmployee"
//                       id="inactiveEmployee"
//                       value="false"
//                       checked={formInput.isEmployee === false}
//                       onChange={handleEmployeeChange}
//                     />
//                     <label className="form-check-label" htmlFor="inactiveEmployee">
//                       No
//                     </label>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-4"></div>
//               <div className="col-md-4"></div>
//               <div className="col-md-4">
//                 <label className="form-label">
//                   Status<span style={{ color: "#EC1117" }}>*</span>
//                 </label>
//                 <div className="form-group" style={{ display: "flex" }}>
//                   <div className="form-check">
//                     <input
//                       type="radio"
//                       className="form-check-input"
//                       name="isActive"
//                       id="activeRadio"
//                       value="true"
//                       checked={formInput.isActive === true}
//                       onChange={handleStatusChange}
//                       color="#EC1117"
//                     />
//                     <label className="form-check-label" htmlFor="activeRadio">
//                       Active
//                     </label>
//                   </div>
//                   <div className="form-check" style={{ marginLeft: "60px" }}>
//                     <input
//                       type="radio"
//                       className="form-check-input"
//                       name="isActive"
//                       id="inactiveRadio"
//                       value="false"
//                       checked={formInput.isActive === false}
//                       onChange={handleStatusChange}
//                     />
//                     <label className="form-check-label" htmlFor="inactiveRadio">
//                       InActive
//                     </label>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer d-flex justify-content-center">
//               {canWriteValue === true ? (
//                 <button type="submit" className="deployment-button">
//                   <i className="fa-solid fa-check done-container"></i>
//                   {editUserData ? t("Update") : t("Save")}
//                 </button>
//               ) : (
//                 ""
//               )}
//             </div>
//           </form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default withTranslation()(UserCreation);












import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from "react-i18next";
import { GetAllRoles, UpdatePassword } from "../../Apis/userCreationApi";
import { CreateUsers } from "../../Apis/userCreationApi";
import { UpdateUsers } from "../../Apis/userCreationApi";
import { GetAllUsers } from "../../Apis/userCreationApi";
import { GetCircleByMultipleZoneId } from "../../Apis/userCreationApi";
import { GetWardByMultipleCircleId } from "../../Apis/userCreationApi";
import { GetZone, GetCirclebyID } from "../../Apis/organizationApi";
import { toast } from "react-toastify";
import axios from "axios";
import { TableLoader } from "../../Common/ShimmerLoader";
import "./userCreation.css";
import Select from "react-select";
import MUITable from "../../Common/MUITable";
import isGHMC from "../../Common/helper/helpar";
import { ExportUsersExcel } from "./exportUsers";
import { StatusBadge } from "../Rfid/utils/statusBadge";

const UserCreation = ({ t }) => {
  const isProd = isGHMC();
  const [lgShow, setLgShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [levels, setLevels] = useState([{ id: 1, value: "" }]);
  const [role, setRole] = useState([]);
  const [users, setUsers] = useState([]);
  const [options, setOptions] = useState([]);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [editUserData, setEditUserData] = useState(null);
  const [selectedRole, setSelectedRole] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [originalZones, setOriginalZones] = useState([]);
  const [circles, setCircles] = useState([]);
  const [wards, setWards] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [zones, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState({});
  const [circleOptions, setCircleOptions] = useState([]);
  const [wardOptions, setWardOptions] = useState([]);
  const [isCirclesEnabled, setIsCirclesEnabled] = useState(false);
  const [isWardsEnabled, setIsWardsEnabled] = useState(false);
  const [isCirclesDropdownOpen, setIsCirclesDropdownOpen] = useState(false);
  const [isWardsDropdownOpen, setIsWardsDropdownOpen] = useState(false);
  const [selectedCircles, setSelectedCircles] = useState({});
  const [isInputValid, setIsInputValid] = useState(true);
  const [canToggleSwitch, setCanToggleSwitch] = useState(false);
  const [isToggleEnabled, setIsToggleEnabled] = useState(false);
  const [isSwitchEnabled, setIsSwitchEnabled] = useState(false);
  const [zonesSelected, setZonesSelected] = useState(false);
  const [error, setError] = useState(null);
  const [password, setPassword] = useState("");
  const [filterOriginalUsersData, setFilterOriginalUsersData] = useState([]);
  const initialFormInput = {
    userName: "",
    employeeCode: "",
    password: "",
    isEmployee: "",
    emailId: "",
    mobileNumber: "",
    roleId: "",
    zoneId: "",
    zoneIds: [],
    circleIds: [],
    wardIds: [],
    isActive: false,
  };
  const [formInput, setFormInput] = useState(initialFormInput);

  const [showPassword, setShowPassword] = useState(false);
  const [passwordshow, setPasswordShow] = useState(false);
  const [associatedTransferStationData, setAssociatedTransferStationData] = useState([]);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handlePasswordToggle = () => {
    setPasswordShow(!passwordshow);
  };

  useEffect(() => {
    setFormInput((prevData) => ({
      ...prevData,
      password: "",
    }));
  }, []);

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setFormSubmitted(false);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    setEditUserData(null);
    setFormInput({
      userName: "",
      employeeCode: "",
      password: "",
      isEmployee: true,
      emailId: "",
      mobileNumber: "",
      roleId: "",
      zoneId: "",
      circleId: "",
      wardId: "",
      zoneIds: [],
      circleIds: [],
      wardIds: [],
      isActive: true,
    });
    setSelectedZones({});
    setWardOptions([]);
    setCircleOptions([]);
    setOptions([]);
  };

  const handleClose = () => {
    setLgShow(false);
    setFormSubmitted(false);
    if (editUserData) {
      setEditUserData(editUserData);
      setFormInput((prevInput) => ({
        ...prevInput,
      }));
    } else {
      setEditUserData(null);
      setFormInput({
        userName: "",
        employeeCode: "",
        isEmployee: true,
        emailId: "",
        mobileNumber: "",
        roleId: "",
        zoneIds: [],
        circleIds: [],
        wardIds: [],
        isActive: true,
        password: "",
      });
      setSelectedZones({});
      setWardOptions([]);
      setCircleOptions([]);
      setOptions([]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await GetAllRoles();
        const sortedRoles = data.sort((a, b) => {
          if (a.isActive === b.isActive) {
            return 0;
          }
          return a.isActive ? -1 : 1;
        });
        setRole(data);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const data = await GetZone();
      if (data === null) {
        setZones([]);
      } else {
        const sortedZoneData = data.sort((a, b) =>
          a.isActive === b.isActive ? 0 : a.isActive ? -1 : 1
        );
        setZones(sortedZoneData);
        setIsOptionsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchCircles();
  }, []);

  const handleCheckboxChange = async (zoneId) => {
    const updatedSelectedZones = {
      ...selectedZones,
      [zoneId]: !selectedZones[zoneId],
    };
    setSelectedZones(updatedSelectedZones);

    const selectedZoneIds = Object.keys(updatedSelectedZones).filter(
      (id) => updatedSelectedZones[id]
    );

    setFormInput((prevData) => ({
      ...prevData,
      zoneIds: selectedZoneIds,
    }));

    if (selectedZoneIds.length > 0) {
      setIsCirclesEnabled(true);
      setIsToggleEnabled(true);

      try {
        const circlesData = await GetCircleByMultipleZoneId(selectedZoneIds);
        const formattedCircles = circlesData.flatMap((zone) =>
          zone.circles.map((circle) => ({
            value: circle.circleId,
            label: circle.circleName,
          }))
        );

        // Filter existing circleIds to keep only those that are still valid
        const validCircleIds = formInput.circleIds.filter((circleId) =>
          formattedCircles.some((circle) => circle.value === circleId)
        );

        setOptions(formattedCircles);
        setCircleOptions(formattedCircles);
        setCircles(circlesData);

        // Update formInput with valid circleIds
        setFormInput((prevData) => ({
          ...prevData,
          circleIds: validCircleIds,
        }));

        // Fetch wards for the valid circleIds
        if (validCircleIds.length > 0) {
          const wardsData = await GetWardByMultipleCircleId(validCircleIds);
          const formattedWards = wardsData.flatMap((circle) =>
            Array.isArray(circle.wards)
              ? circle.wards.map((ward) => ({
                  value: ward.wardId,
                  label: ward.wardName,
                }))
              : []
          );

          // Filter existing wardIds to keep only those that are still valid
          const validWardIds = formInput.wardIds.filter((wardId) =>
            formattedWards.some((ward) => ward.value === wardId)
          );

          setWardOptions([
            { value: "select-all", label: "Select All" },
            ...formattedWards,
          ]);
          setIsWardsEnabled(true);

          setFormInput((prevData) => ({
            ...prevData,
            wardIds: validWardIds,
          }));
        } else {
          setWardOptions([]);
          setIsWardsEnabled(false);
          setFormInput((prevData) => ({
            ...prevData,
            wardIds: [],
          }));
        }
      } catch (error) {
        console.error("Error fetching circles or wards:", error);
        toast.error("Failed to load circles or wards");
      }
    } else {
      setOptions([]);
      setCircleOptions([]);
      setWardOptions([]);
      setIsCirclesEnabled(false);
      setIsToggleEnabled(false);
      setIsCirclesDropdownOpen(false);
      setIsWardsEnabled(false);
      setFormInput((prevInput) => ({
        ...prevInput,
        circleIds: [],
        wardIds: [],
      }));
    }
  };

  const fetchCircles = async () => {
    try {
      const selectedZoneIds = Object.keys(selectedZones).filter(
        (zoneId) => selectedZones[zoneId]
      );
      if (selectedZoneIds.length > 0) {
        const data = await GetCirclebyID({ zoneIds: selectedZoneIds });
        setCircles(data);
      } else {
        setCircles([]);
      }
    } catch (error) {
      console.error("Error fetching circles:", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const [userData, rolesData] = await Promise.all([
        GetAllUsers(),
        GetAllRoles(),
      ]);

      const userDataResponse = userData.map((user) => {
        const roleName =
          rolesData.find(
            (role) => String(role.roleId) === String(user.roleId)
          )?.roleName || "N/A";

        return {
          ...user,
          roleName,
          status: user.isActive ? "Active" : "InActive",
        };
      });

      const sortedUserData = userDataResponse.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setUsers(sortedUserData);
      setFilterOriginalUsersData(sortedUserData);
      setIsOptionsLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setIsOptionsLoading(false);
    }
  };

  const fetchCirclesByMultipleZones = async () => {
    try {
      const zoneIds = Object.keys(selectedZones).filter(
        (zoneId) => selectedZones[zoneId]
      );

      if (zoneIds.length > 0) {
        const data = await GetCircleByMultipleZoneId(zoneIds);

        if (Array.isArray(data)) {
          const formattedOptions = data.flatMap((zone) =>
            Array.isArray(zone.circles)
              ? zone.circles.map((circle) => ({
                  value: circle.circleId,
                  label: circle.circleName,
                }))
              : []
          );

          // Filter existing circleIds to keep only those that are still valid
          const validCircleIds = formInput.circleIds.filter((circleId) =>
            formattedOptions.some((circle) => circle.value === circleId)
          );

          setOptions(formattedOptions);
          setCircleOptions(formattedOptions);
          setCircles(data);

          setFormInput((prevData) => ({
            ...prevData,
            circleIds: validCircleIds,
          }));

          // Fetch wards for the valid circleIds
          if (validCircleIds.length > 0) {
            const wardsData = await GetWardByMultipleCircleId(validCircleIds);
            const formattedWards = wardsData.flatMap((circle) =>
              Array.isArray(circle.wards)
                ? circle.wards.map((ward) => ({
                    value: ward.wardId,
                    label: ward.wardName,
                  }))
                : []
            );

            // Filter existing wardIds to keep only those that are still valid
            const validWardIds = formInput.wardIds.filter((wardId) =>
              formattedWards.some((ward) => ward.value === wardId)
            );

            setWardOptions([
              { value: "select-all", label: "Select All" },
              ...formattedWards,
            ]);
            setIsWardsEnabled(true);

            setFormInput((prevData) => ({
              ...prevData,
              wardIds: validWardIds,
            }));
          } else {
            setWardOptions([]);
            setIsWardsEnabled(false);
            setFormInput((prevData) => ({
              ...prevData,
              wardIds: [],
            }));
          }
        } else {
          console.error("Unexpected data format:", data);
          setOptions([]);
          setCircleOptions([]);
          setWardOptions([]);
          setFormInput((prevData) => ({
            ...prevData,
            circleIds: [],
            wardIds: [],
          }));
        }
      } else {
        setOptions([]);
        setCircleOptions([]);
        setWardOptions([]);
        setFormInput((prevData) => ({
          ...prevData,
          circleIds: [],
          wardIds: [],
        }));
      }
    } catch (error) {
      console.error("Error fetching circles or wards:", error);
      toast.error("Failed to load circles or wards");
      setOptions([]);
      setCircleOptions([]);
      setWardOptions([]);
      setFormInput((prevData) => ({
        ...prevData,
        circleIds: [],
        wardIds: [],
      }));
    }
  };

  useEffect(() => {
    fetchCirclesByMultipleZones();
  }, [selectedZones]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEmployeeChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : false,
    }));
  };

  const handleAddUser = () => {
    setEditUserData(null);
    setFormInput(initialFormInput);
    setSelectedZones({});
    setCircleOptions([]);
    setWardOptions([]);
    setOptions([]);
    setLgShow(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    try {
      setIsOptionsLoading(true);

      const {
        userName,
        employeeCode,
        password,
        isEmployee,
        emailId,
        mobileNumber,
        roleId,
        zoneIds,
        circleIds,
        wardIds,
        isActive,
      } = formInput;

      const requiredFields = editUserData
        ? [userName, employeeCode, emailId, mobileNumber, roleId]
        : [userName, employeeCode, password, emailId, mobileNumber, roleId];

      if (requiredFields.some((field) => !field)) {
        console.error("Please fill all the required fields");
        setIsOptionsLoading(false);
        return;
      }

      const userData = {
        userName,
        employeeCode,
        isEmployee,
        emailId,
        mobileNumber,
        roleId,
        zoneIds: zoneIds.length ? zoneIds : [],
        circleIds: circleIds.length ? circleIds : [],
        wardIds: wardIds.length ? wardIds : [],
        isActive,
      };

      if (editUserData) {
        userData.userId = editUserData.userId;
        if (password?.length > 0) {
          await UpdatePassword(userData.userId, password);
        }
        await UpdateUsers(userData);
        toast.success("User updated successfully!");

        setUsers(
          users.map((user) =>
            user.userId === userData.userId ? { ...user, ...userData } : user
          )
        );
      } else {
        userData.password = password;
        const response = await CreateUsers(userData);
        if (response.status === 200) {
          setUsers([...users, response]);
          toast.success("User added successfully!");
        }
      }

      fetchUsers();
      handleClose();
    } catch (xhr) {
      if (xhr && xhr.response && typeof xhr.response.data.errors === "object") {
        const formErrors = {};
        Object.keys(xhr.response.data.errors).forEach((key) => {
          if (
            Array.isArray(xhr.response.data.errors[key]) &&
            xhr.response.data.errors[key].length > 0
          ) {
            formErrors[key] = xhr.response.data.errors[key][0];
            toast.error(`${key}: ${xhr.response.data.errors[key][0]}`);
          }
        });
      } else {
        toast.error(xhr.response?.data);
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : false,
    }));
  };

  const handleEditUser = async (selectedUser) => {
    if (!selectedUser) {
      console.error("No user data provided for editing.");
      return;
    }

    setEditUserData(selectedUser);
    setIsEditMode(true);
    setLgShow(true);
    setIsOptionsLoading(true);

    // Set selected zones
    const updatedZones = {};
    selectedUser?.zoneIds?.forEach((zoneId) => {
      updatedZones[zoneId] = true;
    });
    setSelectedZones(updatedZones);

    // Set form input with user data
    const activeRole = role.filter(
      (role) => role.roleId === selectedUser?.roleId && role.isActive
    );
    setFormInput({
      userName: selectedUser?.userName || "",
      employeeCode: selectedUser?.employeeCode || "",
      password: "",
      isEmployee: selectedUser?.isEmployee ?? true,
      emailId: selectedUser?.emailId || "",
      mobileNumber: selectedUser?.mobileNumber || "",
      roleId: activeRole.length ? selectedUser?.roleId : "",
      zoneIds: selectedUser?.zoneIds || [],
      circleIds: selectedUser?.circleIds || [],
      wardIds: selectedUser?.wardIds || [],
      isActive: selectedUser?.isActive ?? false,
    });

    try {
      // Fetch circles for the user's zoneIds
      if (selectedUser?.zoneIds?.length > 0) {
        const circlesData = await GetCircleByMultipleZoneId(selectedUser.zoneIds);
        const formattedCircles = circlesData.flatMap((zone) =>
          zone.circles.map((circle) => ({
            value: circle.circleId,
            label: circle.circleName,
          }))
        );
        setOptions(formattedCircles);
        setCircleOptions(formattedCircles);
        setCircles(circlesData);
        setIsCirclesEnabled(true);

        // Fetch wards for the user's circleIds
        if (selectedUser?.circleIds?.length > 0) {
          const wardsData = await GetWardByMultipleCircleId(selectedUser.circleIds);
          const formattedWards = wardsData.flatMap((circle) =>
            Array.isArray(circle.wards)
              ? circle.wards.map((ward) => ({
                  value: ward.wardId,
                  label: ward.wardName,
                }))
              : []
          );
          setWardOptions([
            { value: "select-all", label: "Select All" },
            ...formattedWards,
          ]);
          setIsWardsEnabled(true);
        } else {
          setWardOptions([]);
          setIsWardsEnabled(false);
        }
      } else {
        setOptions([]);
        setCircleOptions([]);
        setWardOptions([]);
        setIsCirclesEnabled(false);
        setIsWardsEnabled(false);
      }
    } catch (error) {
      console.error("Error fetching circles or wards:", error);
      toast.error("Failed to load circles or wards");
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let sanitizedValue = value;

    if (name === "mobileNumber") {
      sanitizedValue = value.replace(/\D/g, "").slice(0, 10);

      if (sanitizedValue.length > 0 && !/^[6789]/.test(sanitizedValue)) {
        console.error("Mobile number must start with 6, 7, 8, or 9");
      }
    } else if (name === "userName" || name === "employeeCode") {
      sanitizedValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
    }

    setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
  };

  const handleMobilenumberChange = (e) => {
    const { name, value } = e.target;
    const numberRegex = /^[0-9]*$/;
    if (value === "" || (numberRegex.test(value) && value.length <= 10)) {
      setFormInput({ ...formInput, [name]: value });
    }
  };

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    const alphabetsOnlyRegex = /^[0-9]*$/;
    if (
      (value === "" || alphabetsOnlyRegex.test(value)) &&
      value.length <= 10
    ) {
      setFormInput({ ...formInput, [name]: value });
    }
  };

  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  storedPermissions = parseInt(storedPermissions, 10);

  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  useEffect(() => {
    const fetchCirclesBySelectedZones = async () => {
      try {
        const zoneIds = Object.keys(selectedZones).filter(
          (zoneId) => selectedZones[zoneId]
        );

        if (zoneIds.length > 0) {
          const data = await GetCircleByMultipleZoneId(zoneIds);

          if (Array.isArray(data)) {
            const formattedCircleOptions = data.flatMap((zone) =>
              zone.circles.map((circle) => ({
                value: circle.circleId,
                label: circle.circleName,
              }))
            );

            // Filter existing circleIds to keep only those that are still valid
            const validCircleIds = formInput.circleIds.filter((circleId) =>
              formattedCircleOptions.some((circle) => circle.value === circleId)
            );

            setCircleOptions(formattedCircleOptions);
            setOptions(formattedCircleOptions);
            setCircles(data);

            setFormInput((prevData) => ({
              ...prevData,
              circleIds: validCircleIds,
            }));

            // Fetch wards for the valid circleIds
            if (validCircleIds.length > 0) {
              const wardsData = await GetWardByMultipleCircleId(validCircleIds);
              const formattedWards = wardsData.flatMap((circle) =>
                Array.isArray(circle.wards)
                  ? circle.wards.map((ward) => ({
                      value: ward.wardId,
                      label: ward.wardName,
                    }))
                  : []
              );

              // Filter existing wardIds to keep only those that are still valid
              const validWardIds = formInput.wardIds.filter((wardId) =>
                formattedWards.some((ward) => ward.value === wardId)
              );

              setWardOptions([
                { value: "select-all", label: "Select All" },
                ...formattedWards,
              ]);
              setIsWardsEnabled(true);

              setFormInput((prevData) => ({
                ...prevData,
                wardIds: validWardIds,
              }));
            } else {
              setWardOptions([]);
              setIsWardsEnabled(false);
              setFormInput((prevData) => ({
                ...prevData,
                wardIds: [],
              }));
            }
          } else {
            console.error("Unexpected data format:", data);
            setCircleOptions([]);
            setOptions([]);
            setWardOptions([]);
            setFormInput((prevData) => ({
              ...prevData,
              circleIds: [],
              wardIds: [],
            }));
          }
        } else {
          setCircleOptions([]);
          setOptions([]);
          setWardOptions([]);
          setFormInput((prevData) => ({
            ...prevData,
            circleIds: [],
            wardIds: [],
          }));
        }
      } catch (error) {
        console.error("Error fetching circles or wards:", error);
        toast.error("Failed to load circles or wards");
        setCircleOptions([]);
        setOptions([]);
        setWardOptions([]);
        setFormInput((prevData) => ({
          ...prevData,
          circleIds: [],
          wardIds: [],
        }));
      }
    };

    fetchCirclesBySelectedZones();
  }, [selectedZones]);

  useEffect(() => {
    const anyZoneSelected = Object.values(selectedZones).some(
      (isSelected) => isSelected
    );

    setCanToggleSwitch(anyZoneSelected);
    setIsCirclesEnabled(anyZoneSelected);

    if (!anyZoneSelected) {
      setIsDropdownOpen(false);
      setIsCirclesDropdownOpen(false);
      setIsWardsEnabled(false);
    }
  }, [selectedZones]);

  useEffect(() => {
    const anyZoneSelected = Object.values(selectedZones).some(
      (isSelected) => isSelected
    );
    setIsSwitchEnabled(anyZoneSelected);

    if (!anyZoneSelected) {
      setIsDropdownOpen(false);
    }
  }, [selectedZones]);

  const handleWardChange = async (selectedOptions) => {
    let selectedValues = [];

    if (selectedOptions && selectedOptions.some((option) => option.value === "select-all")) {
      const allWards = wardOptions.filter((option) => option.value !== "select-all");
      selectedValues = allWards.map((option) => option.value);
    } else {
      selectedValues = Array.isArray(selectedOptions)
        ? selectedOptions.map((option) => option.value)
        : selectedOptions
        ? [selectedOptions.value]
        : [];
    }

    setFormInput((prevState) => ({
      ...prevState,
      wardIds: selectedValues,
    }));

    setIsInputValid(selectedValues.length > 0 || !formSubmitted);
  };

  const handleCircleChange = async (selectedOptions) => {
    let selectedValues = [];

    if (selectedOptions && selectedOptions.some((option) => option.value === "select-all")) {
      const allCircles = options.filter((option) => option.value !== "select-all");
      selectedValues = allCircles.map((option) => option.value);
    } else {
      selectedValues = Array.isArray(selectedOptions)
        ? selectedOptions.map((option) => option.value)
        : selectedOptions
        ? [selectedOptions.value]
        : [];
    }

    setFormInput((prevState) => ({
      ...prevState,
      circleIds: selectedValues,
    }));

    setIsInputValid(selectedValues.length > 0 || !formSubmitted);

    // Fetch wards for the new circleIds
    try {
      if (selectedValues.length > 0) {
        const wardsData = await GetWardByMultipleCircleId(selectedValues);
        const formattedWards = wardsData.flatMap((circle) =>
          Array.isArray(circle.wards)
            ? circle.wards.map((ward) => ({
                value: ward.wardId,
                label: ward.wardName,
              }))
            : []
        );

        // Filter existing wardIds to keep only those that are still valid
        const validWardIds = formInput.wardIds.filter((wardId) =>
          formattedWards.some((ward) => ward.value === wardId)
        );

        setWardOptions([
          { value: "select-all", label: "Select All" },
          ...formattedWards,
        ]);
        setIsWardsEnabled(true);

        setFormInput((prevData) => ({
          ...prevData,
          wardIds: validWardIds,
        }));
      } else {
        setWardOptions([]);
        setIsWardsEnabled(false);
        setFormInput((prevData) => ({
          ...prevData,
          wardIds: [],
        }));
      }
    } catch (error) {
      console.error("Error fetching wards:", error);
      toast.error("Failed to load wards");
      setWardOptions([]);
      setIsWardsEnabled(false);
      setFormInput((prevData) => ({
        ...prevData,
        wardIds: [],
      }));
    }
  };

  const handleCirclesDropdownOpen = () => {
    if (isCirclesEnabled) {
      setIsCirclesDropdownOpen((prevState) => !prevState);
    }
  };

  const handleWardsDropdownOpen = () => {
    if (isWardsEnabled) {
      setIsWardsDropdownOpen((prevState) => !prevState);
    }
  };

  const handleDropdownClose = () => {
    setIsCirclesDropdownOpen(false);
    setIsWardsDropdownOpen(false);
  };

  useEffect(() => {
    const fetchWardsBySelectedCircles = async () => {
      try {
        const circleIds = formInput.circleIds;

        if (circleIds && circleIds.length > 0) {
          const data = await GetWardByMultipleCircleId(circleIds);

          if (Array.isArray(data)) {
            const formattedWardOptions = data.flatMap((circle) =>
              Array.isArray(circle.wards)
                ? circle.wards.map((ward) => ({
                    value: ward.wardId,
                    label: ward.wardName,
                  }))
                : []
            );

            // Filter existing wardIds to keep only those that are still valid
            const validWardIds = formInput.wardIds.filter((wardId) =>
              formattedWardOptions.some((ward) => ward.value === wardId)
            );

            setWardOptions([
              { value: "select-all", label: "Select All" },
              ...formattedWardOptions,
            ]);
            setIsWardsEnabled(true);

            setFormInput((prevData) => ({
              ...prevData,
              wardIds: validWardIds,
            }));
          } else {
            console.error("Unexpected data format:", data);
            setWardOptions([]);
            setIsWardsEnabled(false);
            setFormInput((prevData) => ({
              ...prevData,
              wardIds: [],
            }));
          }
        } else {
          setWardOptions([]);
          setIsWardsEnabled(false);
          setFormInput((prevData) => ({
            ...prevData,
            wardIds: [],
          }));
        }
      } catch (error) {
        console.error("Error fetching wards:", error);
        toast.error("Failed to load wards");
        setWardOptions([]);
        setIsWardsEnabled(false);
        setFormInput((prevData) => ({
          ...prevData,
          wardIds: [],
        }));
      }
    };

    fetchWardsBySelectedCircles();
  }, [formInput.circleIds]);

  useEffect(() => {
    if (formInput.circleIds?.length > 0) {
      setIsWardsEnabled(true);
    } else {
      setWardOptions([]);
      setIsWardsEnabled(false);
      setFormInput((prevData) => ({
        ...prevData,
        wardIds: [],
      }));
    }
  }, [formInput.circleIds]);

  const searchZoneHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalUsersData.filter((item) =>
      item?.userName?.toLowerCase()?.includes(term) ||
      item?.mobileNumber?.toLowerCase()?.includes(term)
    );
    setUsers(data);
  };

  const circleOptionsWithSelectAll = [
    { value: "select-all", label: "Select All" },
    ...options,
  ];

  const usersColumns = [
    {
      label: "User Name",
      field: "userName",
    },
    {
      label: "Role Name",
      field: "roleName",
    },
    {
      label: "Employee Code",
      field: "employeeCode",
    },
    {
      label: "Email",
      field: "emailId",
    },
    {
      label: "Mobile No.",
      field: "mobileNumber",
    },
    {
      label: "Status",
      render: (row) => <StatusBadge isActive={row.isActive} />,
    },
    {
      label: "Action",
      render: (row) => (
        <button
          className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
          onClick={() => {
            handleEditUser(row);
            setLgShow(true);
          }}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
  ];

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{t("Users")}</span>
            </div>
            <div className="row mt-3 align-items-center justify-content-between">
              <div className="col-md-3">
                <div className="form-group mb-0">
                  <input
                    placeholder="Search Username"
                    type="text"
                    className="form-control bg-white"
                    onInput={searchZoneHandler}
                  />
                </div>
              </div>
              <div className="col-md-3 d-flex justify-content-end">
                <div>
                  {/* {canWriteValue === true ? ( */}
                    <button
                      className="button-container ms-auto mr-1"
                      onClick={handleShow}
                    >
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      {t("Add User")}
                    </button>
                  {/* ) : (
                    ""
                  )} */}
                </div>
                <div>
                  <ExportUsersExcel filteredData={users} />
                </div>
              </div>
            </div>
            <div className="card mt-3">
              <div className="card-body p-3">
                <MUITable
                  needSRNumber
                  columns={usersColumns}
                  rows={users}
                  tableHeight={500}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        centered
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editUserData ? t("Edit User") : t("Add User")}
          </Modal.Title>
          <i
            className="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Employee Code
                    <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="employeeCode"
                    placeholder="Enter Emp Code"
                    className={`form-control ${formInput.employeeCode || !formSubmitted ? "" : "input-error"}`}
                    onChange={handleInputChange}
                    value={formInput.employeeCode}
                    maxLength={8}
                    // disabled={!canWriteValue}
                  />
                  {!formInput.employeeCode && formSubmitted && (
                    <div className="required-message">
                      Employee Code is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    User Name
                    <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="userName"
                    placeholder="Enter User Name"
                    className={`form-control ${formInput.userName || !formSubmitted ? "" : "input-error"}`}
                    value={formInput.userName}
                    onChange={handleInputChange}
                    maxLength={42}
                    // disabled={!canWriteValue}
                  />
                  {!formInput.userName && formSubmitted && (
                    <div className="required-message">
                      User Name is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Role Name
                    <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
                  </label>
                  <select
                    className={`form-select ${formInput.roleId || !formSubmitted ? "" : "input-error"}`}
                    name="roleId"
                    value={formInput.roleId}
                    onChange={handleInputChange}
                    // disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {role
                      .filter((role) => role.isActive)
                      .map((role) => (
                        <option key={role.roleId} value={role.roleId}>
                          {role.roleName}
                        </option>
                      ))}
                  </select>
                  {!formInput.roleId && formSubmitted && (
                    <div className="required-message">
                      Role Name is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Email ID
                    <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="emailId"
                    placeholder="Enter Email ID"
                    className={`form-control ${formInput.emailId || !formSubmitted ? "" : "input-error"}`}
                    onChange={handleInputChange}
                    value={formInput.emailId}
                    // disabled={!canWriteValue}
                  />
                  {!formInput.emailId && formSubmitted && (
                    <div className="required-message">Email ID is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Mobile Number
                    <span style={{ color: "#EC1117", margin: "14px 0px 7px 5px" }}>*</span>
                  </label>
                  <input
                    name="mobileNumber"
                    placeholder="Enter Mobile Number"
                    pattern="[0-9]{10}"
                    title="Mobile number must be exactly 10 digits long."
                    className={`form-control ${formInput.mobileNumber || !formSubmitted ? "" : "input-error"}`}
                    onChange={handleMobilenumberChange}
                    value={formInput.mobileNumber}
                    // disabled={!canWriteValue}
                  />
                  {!formInput.mobileNumber && formSubmitted && (
                    <div className="required-message">
                      Mobile Number is Required
                    </div>
                  )}
                  {formInput.mobileNumber &&
                    formInput.mobileNumber.length !== 10 &&
                    formSubmitted && (
                      <div className="required-message">
                        Please enter 10 numbers
                      </div>
                    )}
                </div>
              </div>
              {editUserData ? (
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <label className="form-label">Change Password</label>
                    <div className="input-group">
                      <input
                        type={passwordshow ? "text" : "password"}
                        name="password"
                        id="passwordInput"
                        placeholder="Enter New Password"
                        maxLength={18}
                        className="form-control"
                        value={formInput.password}
                        autoComplete="new-password"
                        onChange={handleInputChange}
                        // disabled={!canWriteValue}
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          onClick={handlePasswordToggle}
                          style={{ cursor: "pointer" }}
                        >
                          <FontAwesomeIcon
                            icon={passwordshow ? faEye : faEyeSlash}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <label className="form-label">
                      Password <span style={{ color: "#EC1117" }}>*</span>
                    </label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        id="passwordInput"
                        placeholder="Enter Password"
                        maxLength={18}
                        className={`form-control ${formInput.password || !formSubmitted ? "" : "input-error"}`}
                        value={formInput.password}
                        onChange={handleInputChange}
                        autoComplete="new-password"
                        // disabled={!canWriteValue}
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          onClick={handleTogglePassword}
                          style={{ cursor: "pointer" }}
                        >
                          <FontAwesomeIcon
                            icon={showPassword ? faEye : faEyeSlash}
                          />
                        </span>
                      </div>
                    </div>
                    {!formInput.password && formSubmitted && (
                      <div className="required-message">
                        Password is Required
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="col-md-12 mb-3">
                <div className="form-label">Select Zones</div>
                <div className="form-check">
                  <div className="form-group" style={{ display: "flex" }}>
                    {isOptionsLoading ? (
                      <p>Loading zones...</p>
                    ) : zones.length > 0 ? (
                      <form className="d-flex gap-3 flex-wrap">
                        {zones.map((zone) => (
                          <span key={zone.zoneId} className="w-15">
                            <label>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                value={formInput.zoneIds}
                                checked={selectedZones[zone.zoneId] || false}
                                onChange={() => handleCheckboxChange(zone.zoneId)}
                              />
                              {zone.zoneName}
                            </label>
                          </span>
                        ))}
                      </form>
                    ) : (
                      <p>No zones available</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="row align-items-end">
                    <div className="col-md-2">
                      <div className="form-group">
                        <span
                          className="form"
                          style={{
                            transform: isCirclesEnabled ? "translateX(14px)" : "translateX(0)",
                            backgroundColor: isCirclesEnabled ? "#2196F3" : "#ccc",
                          }}
                        ></span>
                      </div>
                    </div>

                    <div className="col-md-10">
                      <div className="form-group">
                        <label className="form-label">Wards</label>
                        <div className="select-container" onClick={handleCirclesDropdownOpen}>
                          <Select
                            classNamePrefix="CreatableSelect"
                            className={`select-component ${!formInput.circleIds?.length && formSubmitted ? "input-error" : ""}`}
                            id="circleIds"
                            name="circleIds"
                            value={circleOptionsWithSelectAll.filter((option) =>
                              formInput.circleIds?.includes(option.value) && option.value !== "select-all"
                            )}
                            onChange={handleCircleChange}
                            isMulti
                            options={circleOptionsWithSelectAll}
                            isDisabled={!isCirclesEnabled}
                            menuIsOpen={isCirclesDropdownOpen}
                            onMenuClose={handleDropdownClose}
                            isLoading={isOptionsLoading}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-md-6">
                  <div className="row align-items-end">
                    <div className="col-md-2">
                      <div className="form-group">
                        <span
                          className="form"
                          style={{
                            transform: isWardsEnabled ? "translateX(14px)" : "translateX(0)",
                            backgroundColor: isWardsEnabled ? "#2196F3" : "#ccc",
                          }}
                        ></span>
                      </div>
                    </div>
                    <div className="col-md-10">
                      <div className="form-group">
                        <label className="form-label">Wards</label>
                        <div className="select-container" onClick={handleWardsDropdownOpen}>
                          <Select
                            classNamePrefix="CreatableSelect"
                            className={`select-component ${!formInput.wardIds?.length && formSubmitted ? "input-error" : ""}`}
                            id="wardIds"
                            name="wardIds"
                            value={wardOptions.filter((wardOption) =>
                              formInput.wardIds?.includes(wardOption.value) && wardOption.value !== "select-all"
                            )}
                            onChange={handleWardChange}
                            isMulti
                            options={wardOptions}
                            isDisabled={!isWardsEnabled}
                            menuIsOpen={isWardsDropdownOpen}
                            onMenuClose={handleDropdownClose}
                            placeholder="Select Wards"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Is Employee<span style={{ color: "#EC1117" }}>*</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isEmployee"
                      id="activeEmployee"
                      value="true"
                      checked={formInput.isEmployee === true}
                      onChange={handleEmployeeChange}
                      color="#EC1117"
                    />
                    <label className="form-check-label" htmlFor="activeEmployee">
                      Yes
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isEmployee"
                      id="inactiveEmployee"
                      value="false"
                      checked={formInput.isEmployee === false}
                      onChange={handleEmployeeChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveEmployee">
                      No
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-md-4"></div>
              <div className="col-md-4"></div>
              <div className="col-md-4">
                <label className="form-label">
                  Status<span style={{ color: "#EC1117" }}>*</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      value="true"
                      checked={formInput.isActive === true}
                      onChange={handleStatusChange}
                      color="#EC1117"
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      value="false"
                      checked={formInput.isActive === false}
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {/* {canWriteValue === true ? ( */}
                <button type="submit" className="deployment-button">
                  <i className="fa-solid fa-check done-container"></i>
                  {editUserData ? t("Update") : t("Save")}
                </button>
              {/* ) : (
                ""
              )} */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(UserCreation);